import {SidebarMain} from '@sollapay/ui/components';
import {NavigationHistoryProvider} from '@sollapay/web-core';
import {Outlet} from 'react-router-dom';

import {RequiredProfileGate} from '@/features/account-settings';
import {useRealtimeUpdates} from '@/hooks';

import {AppSidebar} from './AppSidebar';
import {Footer} from './Footer';

import type {FC} from 'react';

export const MainLayout: FC = () => {
  useRealtimeUpdates();

  return (
    <NavigationHistoryProvider>
      <AppSidebar>
        <SidebarMain className="overflow-hidden">
          <Outlet />
          <Footer />
        </SidebarMain>
      </AppSidebar>
      <RequiredProfileGate />
    </NavigationHistoryProvider>
  );
};
